import React, { useEffect } from "react";

import BenefitsImage from "../../assets/Benefits.png";
import Confetti3 from "../../assets/confetti3.png";
import Confetti4 from "../../assets/confetti4.png";

import AOS from "aos";
import "aos/dist/aos.css";

const Benefits = (props) => {
  useEffect(() => {
    AOS.init({
      duration: 3500,
    });
  }, []);

  return (
    <div id="Benefits">
      <h2 data-aos={"fade-right"} className="Benefits__title">
        What are the Benefits of Ziplyne?
      </h2>
      <p data-aos={"fade-right"} className="Benefits__description">
        Ziplyne was designed with the user in mind with an aim of providing an experience that
        is simultaneously low-touch and productive.
        <br />
        <br />
        We believe that in-app guidance should resemble an actual Zip Line,
        leading the user through an efficient and direct journey that is both
        pain-free and engaging.
        <br />
        <br />
        Partnering with a solution like Ziplyne allows us to provide scalable training on top of any 
        application without having to worry about retraining end users on the basis of new releases, updates, migrations, etc. 
      </p>
      <img
        data-aos={"fade-left"}
        className="Benefits--background"
        src={BenefitsImage}
        alt=""
      />
      <img className="Benefits__confetti--3" src={Confetti3} alt="" />
      <img className="Benefits__confetti--4" src={Confetti4} alt="" />
    </div>
  );
};

export default Benefits;
